import { useState } from "react";
import { useData } from "@/stores/data";
import moment from "moment";
import axios from "axios";
import {userToken} from "@/helpers/h";

function ExportDataButton({ fileType }) {
    const [exporting, setExporting] = useState(false);
    return (
        <button
            disabled={exporting}
            className="purple-button inline-block"
            onClick={async () => {
                setExporting(true);
                try {
                    await axios({
                        method: "GET",
                        responseType: "blob",
                        url: `${import.meta.env.VITE_API_BASE_URL}/api/v2/export/${fileType}`,
                        headers: {
                            "Authorization": `Bearer ${userToken()}`
                        },
                    })
                        .then(res => {
                            const url = window.URL.createObjectURL(new Blob([res.data]));
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = moment().format('YYYY-MM-DD') + '_' + fileType + '.csv';
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                        })
                } catch {
                    // console.log(error);
                } finally {
                    setExporting(false);
                }
            }}
        >
            {exporting ? "Exporting..." : "Export Data"}
        </button>
    );
}

export default function ImportElement(props) {
    const [mappingAreaLoading, setMappingAreaLoading] = useState(false);
    const {setCurrentImport} = useData();
    const hasTemplate = [
        "machine",
        "asset",
        "part_repairable",
        "part_non_repairable",
        "manager",
        "team_leader",
        "first_level_maintenance",
        "cash_in_transit",
        "service_engineer",
    ].includes(props.fileType);
    return (
        <>
            {hasTemplate ? (
                <>
                    <h4>
                        <b>1. </b>Before you import, please make your csv format look like this{" "}
                        <b>Template</b>.
                    </h4>
                    <div className="flex flex-wrap gap-[8px]">
                        <a
                            href={`${import.meta.env.VITE_API_BASE_URL}/import_format/${
                                props.fileType
                            }_import.csv`}
                            download={true}
                            className="purple-button inline-block"
                        >
                            Download Template
                        </a>
                        <ExportDataButton fileType={props.fileType} />
                    </div>
                    <h4>
                        <b>2. </b>If your format is the same as the <b>Template</b>, please upload
                        your csv file below.
                    </h4>
                </>
            ) : null}
            {props.fileType == "mapping_area" && (
                <>
                    <h4>
                        <b>1. </b>Before you continue, please make sure the manager{" "}
                        <button
                            className="text-blue-500"
                            onClick={() => {
                                setCurrentImport("manager");
                            }}
                        >
                            Manager
                        </button>
                        ,{" "}
                        <button
                            className="text-blue-500"
                            onClick={() => {
                                setCurrentImport("team_leader");
                            }}
                        >
                            Team Leader
                        </button>
                        ,{" "}
                        <button
                            className="text-blue-500"
                            onClick={() => {
                                setCurrentImport("service_engineer");
                            }}
                        >
                            Service Engineer
                        </button>
                        ,{" "}
                        <button
                            className="text-blue-500"
                            onClick={() => {
                                setCurrentImport("first_level_maintenance");
                            }}
                        >
                            First Level Maintenance
                        </button>
                        , and{" "}
                        <button
                            className="text-blue-500"
                            onClick={() => {
                                setCurrentImport("cash_in_transit");
                            }}
                        >
                            Cash In Transit
                        </button>
                        , are already imported.
                    </h4>
                    <h4>
                        <b>2. </b>Before you import, please make your csv format look like this{" "}
                        <b>Template</b>.
                    </h4>
                    <div className="flex flex-wrap gap-[8px]">
                        <button 
                            disabled={mappingAreaLoading}
                            className="purple-button inline-block"
                            onClick={async () => {
                                setMappingAreaLoading(true);
                                try {
                                    await axios({
                                        method: "GET",
                                        responseType: "blob",
                                        url: `${import.meta.env.VITE_API_BASE_URL}/api/v2/mapping_area/import_format/csv`,
                                        headers: {
                                            "Authorization": `Bearer ${userToken()}`
                                        },
                                    })
                                        .then(res => {
                                            const url = window.URL.createObjectURL(new Blob([res.data]));
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.download = moment().format('YYYY-MM-DD') + '_mapping_area_template.csv';
                                            document.body.appendChild(a);
                                            a.click();
                                            a.remove();
                                        })
                                } catch {
                                    // console.log(error);
                                } finally {
                                    setMappingAreaLoading(false);
                                }
                            }}
                        >
                            {mappingAreaLoading ? "Downloading..." : "Download Template"}
                        </button>
                        <ExportDataButton fileType={props.fileType} />
                    </div>
                    <h4>
                        <b>3. </b>If your format is the same as the <b>Template</b>, please upload
                        your csv file below.
                    </h4>
                </>
            )}
            {!hasTemplate && props.fileType != "mapping_area" && (
                <div>
                    <ExportDataButton fileType={props.fileType} />
                </div>
            )}
        </>
    );
}
